import {
  Component,
  OnInit,
  OnDestroy,
  Output,
  EventEmitter,
  Input,
  ChangeDetectorRef,
  AfterViewChecked,
} from "@angular/core";
import { Product } from "src/app/models/onboarding.model";
import { OnboardingService } from "src/app/services/onboarding.service";
import { Subject } from "rxjs";
import { ShareAmountService } from "src/app/services/share-amount.service";
import { DataShareService } from "src/app/services/data-share.service";
import { takeUntil } from "rxjs/operators";
import { StorageKeyEnum } from "src/app/core/StorageKeyEnum";
import { AuthService } from "./../../services/auth.service";
import { MatDialog } from "@angular/material/dialog";
import { SettingFeedbackDailogComponent } from "../dialogs/setting-feedback-dailog/setting-feedback-dailog.component";

@Component({
  selector: "app-products",
  templateUrl: "./billing.component.html",
  styleUrls: ["./billing.component.scss"],
})
export class ProductsComponent implements OnInit, AfterViewChecked ,OnDestroy {
  orderAmount:number = 0;
  products: Product[]=[];
  currentPrice: number;
  newPrice: number;
  newTiers: number[] = [];
  spin: boolean = false;
  isNothingSelected: boolean;
  tierChange: boolean;
  currentTier: number[] = [];
  @Input() isOnBoarding;
  nextBillingDate = new Date();
  redirectedTier;
  @Output() newPriceOutput: EventEmitter<number> = new EventEmitter();
  @Output() tierOutput: EventEmitter<number[]> = new EventEmitter();
  @Output() changedSubscription: EventEmitter<boolean> = new EventEmitter();
  @Output() productsOutput: EventEmitter<string[]> = new EventEmitter();
  private destroy$ = new Subject<void>();

  constructor(
    private onboardingService: OnboardingService,
    private shareAmountService: ShareAmountService,
    private authService: AuthService,
    private dataShareService: DataShareService,
    private dialog:MatDialog,
    private cdr: ChangeDetectorRef
  ) {
    this.shareAmountService.getNewObservableValue.pipe(takeUntil(this.destroy$)).subscribe((newObsValue) => {
      if(newObsValue){
      this.orderAmount = newObsValue.amount;
      if (this.orderAmount) this.setTierAccordingToOrders(this.orderAmount,newObsValue.product);
      }
    });
    this.shareAmountService.cancelSubscription$.pipe(takeUntil(this.destroy$)).subscribe((res) => {
      if (res) this.loadProducts();
    });
  }

  ngOnInit() {
    this.authService._tierIdObs$
      .pipe(takeUntil(this.destroy$))
      .subscribe((e) => {
        if (e) {
          var ids=e.split(',')
          this.redirectedTier = ids;
        }
      });
    this.loadProducts();
    this.authService.userInfo$.pipe(takeUntil(this.destroy$)).subscribe((e) => {
      if (e) {
        this.nextBillingDate.setMonth(this.nextBillingDate.getMonth() + 1);
        this.nextBillingDate.setDate(e.cycleDay);
      }
    });
  }

  ngAfterViewChecked(): void {
    this.cdr.detectChanges();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }

  loadProducts() {
    this.currentTier=[]
    this.onboardingService.ListProducts().pipe(takeUntil(this.destroy$)).subscribe((e: any) => {
      // this.products=e.products.filter((res)=> !(res.name === 'Netyard' && this.isOnBoarding));
     this.products = e.products;
      this.currentPrice = this.getTotalPrice(this.products);
      this.isNothingSelected = this.products
        .map((product: Product) => {
          const index = product.tiers.findIndex((tier) => tier.isSelected);
          if (index != -1) {
            this.currentTier.push(product.tiers[index].tierId);
            product.tiers[index].currentSelected = true;
          }
          return index === -1;
        })
        .every((item) => item === true);
      this.productsOutput.emit(this.getSelectedProducts());
      if (this.redirectedTier) {
        this.products.forEach((ele) => {
          ele.tiers.forEach((tier) => (tier.isSelected = false));
          const index = ele.tiers.forEach(
            (tier) => {
              this.redirectedTier.forEach((id)=>{
                if(tier.tierId == id) tier.isSelected=true
              })
            });
        });
      }
    });
  }

  getTotalPrice(products) {
    return products
      .map((product) => {
        const priceArray = product.tiers.find((tier) => tier.isSelected);
        return priceArray ? priceArray.price : 0;
      })
      .reduce((acc, cur) => acc + cur);
  }

  getTierArray() {
    return this.products
      .map((product) => {
          const array = product.tiers.find((tier) => tier.isSelected);
          return array ? array.tierId : null;
      })
      .filter((el) => el != null);
  }

  getSelectedProducts(): string[] {
    return this.products
      .filter((product) => product.tiers.find((tier) => tier.isSelected))
      .map((product) => product.name);
  }

  saveTier() {
    let selectedProductIds=[];
    this.products.filter((product:any)=>{
      const selectedProduct= product.tiers.filter((res)=>res.isSelected && !res.currentSelected);
      if(product.isRemoved){
        selectedProductIds.push(product.productId);
      }
    })
    if(selectedProductIds.length){
      this.dialog.open(SettingFeedbackDailogComponent, {
        width: "500px",
        disableClose: true,
        data: {
          selectedProductIds:selectedProductIds
        }
      }).afterClosed()
        .pipe()
        .subscribe((e) => {
        if (e == "Submit") {
         this.save();
        }
      });
    } else{
      this.save();
    }
  }

  save(){
    this.spin = true;
    const tierArray = this.getTierArray();
    this.onboardingService
    .SaveTierSelection({ tiers: tierArray }).pipe(takeUntil(this.destroy$)).subscribe({
      next: (res) => {
        this.spin = false;
        this.authService.GetCurrentUser().pipe(takeUntil(this.destroy$)).subscribe((e) => {
          localStorage.setItem(StorageKeyEnum.User, JSON.stringify(e));
          window.location.reload();
        });
      },
     error: (err) => {
      this.spin = false;
     }
   });
  }

  selectTier(product?) {
    if(product?.productId){
      const index= this.products.findIndex((res)=>res.productId == product.productId);
      this.products[index].isRemoved=true;
    } 
    this.newPrice = this.getTotalPrice(this.products);
    const newTiers = this.getTierArray();
    let index;
    let count = 0;
    if(this.currentTier.length){
      this.tierChange = JSON.stringify(this.currentTier.sort()) !== JSON.stringify(newTiers.sort());
      this.authService.tierChangeRoute = this.tierChange;
    }
    else {
      newTiers.length ? this.tierChange = true : this.tierChange = false;
    }
    this.newTiers = newTiers;
    this.newPriceOutput.emit(this.newPrice);
    this.tierOutput.emit(this.newTiers);
    this.productsOutput.emit(this.getSelectedProducts());
  }

  setTierAccordingToOrders(orderCount,productName) {
    this.products.forEach((product) => {
    if (!product.comingSoon && product.name === productName) {
      const isTierSelected = product.tiers.some((tier) => tier.isSelected);
      var maxOrder = product.tiers.slice(-2)[0]?.upto;
      this.deselectTier(product);
      const nextTierIndex = product.tiers.findIndex((tier) => {
        if (maxOrder < orderCount && tier.upto == -1) return true;
         else if(tier.upto >= orderCount) {
          return true;
        }
      });
      if (nextTierIndex != -1) {
        product.tiers[nextTierIndex].isSelected = true;
        this.dataShareService.change({tierId:product.tiers[nextTierIndex].tierId,product:productName});
        this.setFeatureAccordingToOrders(product.tiers[nextTierIndex]);
      }
    }
  });
  this.selectTier();
  }
  setFeatureAccordingToOrders(tier) {
    this.deselectFeature();
    this.products.forEach((product) => {
      product.features.forEach((feature) => {
        if (tier.tierId == feature.minTier) {
          feature.isSelected = true;
          return true;
        }
      });
    });
  }

  deselectTier(product) {
    const index = product.tiers.findIndex((tier) => tier.isSelected);
    if (index != -1) {
      product.tiers[index].isSelected = false;
    }
  }
  // inputOrderAmount(value, event) {
  //   if (event.which >= 37 && event.which <= 40) event.preventDefault();
  //   else {
  //     value = Number(value.replace(/,/g, ""));
  //     this.setTierAccordingToOrders(value,'shipyard');
  //     return (event.target.value = event.target.value
  //       ?.replace(/\D/g, "")
  //       .replace(/\B(?=(\d{3})+(?!\d))/g, ","));
  //   }
  // }
  deselectFeature() {
    this.products.forEach((products) => {
      products.features.forEach((feature) => (feature.isSelected = false));
    });
  }

  cancel(){
    this.loadProducts();
  }
}
